import { scrollAndFocus, scrollToTop } from 'platform/utilities/scroll';

export function setFocus(selector) {
  const el =
    typeof selector === 'string' ? document.querySelector(selector) : selector;
  if (el) {
    el.setAttribute('tabIndex', -1);
    el.focus();
  }
}

export function setPageFocus(selector = 'h1') {
  const el = document.querySelector(selector);
  if (el) {
    scrollAndFocus(el, { behavior: 'instant' });
  } else {
    setFocus('#main h1');
  }
}

export function setUpPage(scroll = true, focusSelector = 'h1') {
  if (!scroll) {
    scrollToTop({ behavior: 'instant' });
  }
  scrollAndFocus(document.querySelector(focusSelector), {
    behavior: 'instant',
  });
}

export function isTab(url) {
  return (
    url &&
    (url.endsWith('status') ||
      url.endsWith('files') ||
      url.endsWith('details') ||
      url.endsWith('overview'))
  );
}

// va-details renders its <summary>/<details> inside a shadow root and
// intentionally doesn't expose an `open` property, so it can't be toggled
// the way a native <details> element can. Reach into the shadow root and
// click the summary (the component's own toggle handler) to open it.
export const openMailFaxDetails = (id = 'mail-fax-details') => {
  const host = document.getElementById(id);
  const summary = host?.shadowRoot?.querySelector('summary');
  const details = host?.shadowRoot?.querySelector('details');
  if (summary) {
    if (details && !details.open) {
      summary.click();
    }
    setFocus(summary);
  }
};

export const focusNotificationAlert = () => {
  const alert = document.querySelector('.claims-alert');
  if (alert) {
    // Focus headline to preserve SHIFT+TAB navigation to alert's interactive elements
    const headline = alert.querySelector('h2');
    if (headline) {
      setFocus(headline);
    } else {
      setFocus(alert);
    }
  }
};
